<p>step3 works!</p>
<div class="navLinks">
  <ul>
    <li><a [routerLink]="['/encoding/step3/sub1']">Sub1</a></li>
    <li><a [routerLink]="['/encoding/step3/sub2']">Sub2</a></li>
    <li><a [routerLink]="['/encoding/step3/sub3']">Sub3</a></li>
  </ul>
</div>
<router-outlet></router-outlet>
